<template>
  <div class="cooperation page-wrap">
    <el-row>
      <el-col :span="4">
        <slideTab :tabList="tabList" @selectKey="getSelectKey"></slideTab>
      </el-col>
      <el-col :span="18" v-if="activeIndex === 'intro'">
          <p>小猪民宿一直致力于为旅行者提供完美的住宿产品和旅行体验，市场份额持续领先。向同业采购房源、度假产品等旅游资源，通过PC、APP、小程序等多元化渠道对外销售。并为用户提供从预订到出游等一站式服务。为聚合更多优质资源，小猪开放平台专门为各大供应商、分销商等提供技术服务，让旅游企业同行交易突破时间、地域的限制，提升效率，降低交易成本，与小猪一起实现资源共享、市场共赢。</p>
      </el-col>
      <el-col :span="18" v-if="activeIndex === 'mode'">
          <h6>链接跳转</h6>
          <p>合作伙伴网站、APP或微信公众号通过链接跳转至小猪的H5页面，并可实现联合登录。即用户在合作伙伴登录后，到达小猪H5页面时即可成为小猪的用户。</p>
          <p> 特点：合作伙伴开发量小，上线快。H5的UI体验与小猪官方一致。</p>
          <h6>API集成</h6>
          <p>合作伙伴通过服务器调用小猪开放平台的API，获取产品数据，完成用户的预订，进行订单查询、更改或取消。对用户来说他面对的都是合作伙伴的网站，用户体验一致。</p>
          <p>特点：合作伙伴预订平台更加自由化， UI/UE可自由定义，数据本地化，有助于合作伙伴进行用户数据分析及营销。</p>
      </el-col>
      <el-col :span="18" v-if="activeIndex === 'process'">
          <h6>在合作正式对接前，请您完成以下几项工作：</h6>
          <p>1、 充分了解贵司平台业务对接需求：整个交易流程是闭环模式或跳转至小猪平台完成交易；</p>
          <p>2、是否有登录、推单、支付需求；</p>
          <p>3、房源订单中心是在贵司平台或小猪平台。</p>
          <p>如有合作意愿请发送邮件至apihezuo@xiaozhu.com。</p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import slideTab from "../components/slideTab.vue";
export default {
  name: "Cooperation",
  components: {
    slideTab
  },
  data() {
    return {
      activeIndex: 'intro',
      tabList: [
        {
          text: "业务介绍",
          name: "intro",
          children: []
        },
        {
          text: "合作模式",
          name: "mode",
          children: []
        },
        {
          text: "合作流程",
          name: "process",
          children: []
        }
      ]
    };
  },
  methods: {
    getSelectKey(key) {
        this.activeIndex = key
      console.log(key);
    }
  }
};
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
.cooperation {
  // background: url("../assets/images/Back-cooperation.jpg") no-repeat center
  //   center;
  // background-size: 100% 100%;
  min-height: 100vh;
}
</style>
